import style from "./ProfileEmptyTab.module.css";

import Icon from "@/ui/icon/Icon";

function ProfileEmptyTab({ title, description, icon }) {
	return (
		<div className={style.emptyHolder}>
			<div className={style.icoHolder}>
				<Icon icon={icon} />
			</div>
			<h3>{title}</h3>
			<p>{description}</p>
		</div>
	);
}

export default ProfileEmptyTab;
